import React from 'react';
import { Container, Typography } from '@mui/material';
import Seo from '../components/seo/Seo';

const Bailouts = () => {
  return (
    <>
      <Seo
        title="Betonoki - Bailouts"
        description="Strona informacyjna Betonoki."
        path="/bailouts"
        noindex
      />
      <Container>
        <Typography variant="h1" gutterBottom>
          Bailouts
        </Typography>
        <Typography>This is the Bailouts page. Here you can learn more Bailouts</Typography>
      </Container>
    </>
  );
};

export default Bailouts;
